import React from "react";

const Main = ({ children, theme }) => (
  <main className={`text-base ${theme} t-page`}>{children}</main>
);

export default Main;
